export const name = "INT64";
export const summary = `Converts a JSON number to a SQL \`INT64\` value.`;
export const reference = `
## INT64

Converts a JSON number to a SQL \`INT64\` value.

\`\`\`
INT64(json_expr)
\`\`\`

### Description

Converts a JSON number to a SQL \`INT64\` value.

Arguments:

- \`json_expr\`: JSON. For example:


### Return type

\`INT64\`


### Examples



\`\`\`
SELECT INT64(JSON '2005') AS flight_number;

/*---------------*
 | flight_number |
 +---------------+
 | 2005 |
 *---------------*/
\`\`\`



\`\`\`
SELECT INT64(JSON_QUERY(JSON '{"gate": "A4", "flight_number": 2005}', "$.flight_number")) AS flight_number;

/*---------------*
 | flight_number |
 +---------------+
 | 2005 |
 *---------------*/
\`\`\`



\`\`\`
SELECT INT64(JSON '10.0') AS score;

/*-------*
 | score |
 +-------+
 | 10 |
 *-------*/
\`\`\`

The following examples show how invalid requests are handled:



\`\`\`
-- An error is thrown if JSON isn't a number or can't be converted to a 64-bit integer.
SELECT INT64(JSON '10.1') AS result; -- Throws an error
SELECT INT64(JSON '"strawberry"') AS result; -- Throws an error
SELECT INT64(JSON 'null') AS result; -- Throws an error
SELECT SAFE.INT64(JSON '"strawberry"') AS result; -- Returns a SQL NULL
\`\`\`


source: https://cloud.google.com/bigquery/docs/reference/standard-sql/json_functions
`;
